import React from 'react';
import { homepageContent, siteContent } from '../../data/products';
import Icon from '../Icon/Icon';
import './Footer.css';

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
const Footer = ({ onReplayIntro }) => {
  const content = homepageContent.footer;
  const instagramUrl = siteContent.contact.instagramUrl;
  const orderLink = `https://wa.me/${siteContent.contact.whatsappNumber}`;
  const waOrder = `${orderLink}?text=${encodeURIComponent(`Hi ${siteContent.brand.name}! I'd like to plan an order.`)}`;
  const phoneHref = `tel:+${siteContent.contact.whatsappNumber}`;
  const legalLine = [
    siteContent.legal.fssaiStatus,
    siteContent.legal.fssaiNumber ? `Lic. No. ${siteContent.legal.fssaiNumber}` : '',
    siteContent.legal.egglessNotice
  ].filter(Boolean).join(' · ');

  return (
  <footer className="footer">
    {/* Closing call-to-action band */}
    <div className="footer-cta">
      <div className="footer-cta-text">
        <span className="footer-cta-kicker">{content.ctaEyebrow}</span>
        <h3>{content.ctaTitle}</h3>
      </div>
      <a href={waOrder} target="_blank" rel="noreferrer" className="footer-cta-btn">
        <Icon name="whatsapp" size={18} />
        <span>{content.ctaLabel}</span>
      </a>
    </div>

    <div className="footer-main">
      <div className="footer-brand">
        <div className="footer-id">
          <img src={siteContent.brand.logo} alt={siteContent.brand.logoAlt} />
          <div>
            <strong>{siteContent.brand.name}</strong>
            <span>{siteContent.brand.tagline}</span>
          </div>
        </div>
        <p className="footer-tagline">
          {content.tagline}
        </p>
        <div className="footer-socials">
          <a href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram"><Icon name="instagram" size={16} /></a>
          <a href={waOrder} target="_blank" rel="noreferrer" aria-label="WhatsApp"><Icon name="whatsapp" size={16} /></a>
          <a href={phoneHref} aria-label="Call"><Icon name="phone" size={16} /></a>
        </div>
      </div>

      <div className="footer-col">
        <h4>Explore</h4>
        <ul>
          {[['menu','Menu'],['about','Our Story'],['gallery','Gallery'],['order','Order']].map(([id, label]) => (
            <li key={id}><button onClick={() => scrollTo(id)}>{label}</button></li>
          ))}
        </ul>
      </div>

      <div className="footer-col footer-visit">
        <h4>Visit &amp; Order</h4>
        <p className="footer-line"><Icon name="pin" size={16} /><span>{siteContent.contact.address}</span></p>
        <p className="footer-line"><Icon name="phone" size={16} /><a href={phoneHref}>{siteContent.contact.phoneDisplay}</a></p>
        <p className="footer-line"><Icon name="shield" size={16} /><span>{legalLine}</span></p>
        <p className="footer-line"><Icon name="star" size={16} /><span>{content.hoursLine}</span></p>
        <a
          className="footer-reviews"
          href={siteContent.contact.mapSearchUrl}
          target="_blank"
          rel="noreferrer"
        >
          <Icon name="star" size={14} />
          <span>{content.reviewLabel}</span>
        </a>
      </div>
    </div>

    <div className="footer-bottom">
      <span>{content.copyright}</span>
      {onReplayIntro && (
        <button type="button" className="footer-replay" onClick={onReplayIntro}>
          Replay intro
        </button>
      )}
      <span className="footer-made">{content.closingLine}</span>
    </div>
  </footer>
  );
};
export default Footer;
